import { FormFields } from '../../../../../models/newSupportCall';
import { getTasAdditionalFields } from "../../tasAdditionalRequiredFields";

interface TasAdditionalFieldsProps {
    subject: string;
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
}

const fieldColumnClassName = 'form-group form-group-lg flex-1-1';

const TasAdditionalFields = ({ subject, formData, errors, updateField }: TasAdditionalFieldsProps) => {
    const fields = getTasAdditionalFields(subject);
    const inputFields = fields.filter(field => field.inputType === 'input');
    const textareaFields = fields.filter(field => field.inputType === 'textarea');

    return (
        <div className='margin-top-20'>
            <p className='text-size-16 text-bold'>2. Dados adicionais</p>
            <div className='padding-15 margin-top-20 rounded border'>
                {inputFields.length > 0 ? (
                    <div className='display-flex gap-20'>
                        {inputFields.map(field => (
                            <div className={fieldColumnClassName} key={field.field}>
                                <label className='text-size-14 text-color-darker margin-bottom-10'>
                                    {field.label} *
                                </label>
                                <input
                                    type='text'
                                    className='form-control'
                                    placeholder="Obrigatório"
                                    value={String(formData[field.field] ?? '')}
                                    onChange={event => updateField(field.field, event.target.value)}
                                />
                                {errors[field.field] ? (
                                    <span className='text-size-12 text-color-danger'>{errors[field.field]}</span>
                                ) : null}
                            </div>
                        ))}
                    </div>
                ) : null}
                {textareaFields.map((field, index) => (
                    <div className={(inputFields.length > 0 || index > 0) ? 'margin-top-20' : undefined} key={field.field}>
                        <p className='text-size-14 text-color-darker'>{field.label} *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={String(formData[field.field] ?? '')}
                            onChange={event => updateField(field.field, event.target.value)}
                        />
                        {errors[field.field] ? (
                            <span className='text-size-12 text-color-danger'>{errors[field.field]}</span>
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TasAdditionalFields;
